export const NumberOfStages = {
    name: "NumStages",
    run: (fact, emit) => {
        if(fact.stages.length > 3) {
            emit(`You are using ${fact.stages.length} stages which is more than the suggested maximum of 3 stages.`, 'warning')
        }
    }
  }



